angular.module('impactx.panel').directive('ixCatalogPreviewPanel', CatalogPreviewPanelDirective);

function CatalogPreviewPanelDirective() {
    return {
        restrict: 'EA',
        controller: 'CatalogPreviewPanelCtrl',
        controllerAs: 'catalogPreviewPanelCtrl',
        scope: true,
        bindToController: {
            name: "=",
            image: "=",
            supplier: "=",
            trns: "=",
            creator: "@",
            color: "=",
            isExternal: "="
        },
        templateUrl: 'shared/panel/templates/catalog.preview.panel.tmpl.html'
    }
}